import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const NotificationsBody = styled(Box)(() => ({
  maxHeight: "450px",
  overflow: "auto",
}));
